



import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaUserCircle } from "react-icons/fa";
import Footer from "./Footer";
import { FaRegStar, FaStar } from "react-icons/fa6";

const formatDate = (d) =>
  new Date(d).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

export default function ReviewsUs() {
  const [reviewOpen, setReviewOpen] = useState(false);
  const [reviewText, setReviewText] = useState("");
  const [rating, setRating] = useState(0);
  const [toast, setToast] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const [pageContent, setPageContent] = useState({
    title: "",
    description: "",
    banner_image: "",
  });
  const [pick, setPick] = useState(null);
  const [steps, setSteps] = useState([]);
  const [reviews, setReviews] = useState([]);

  const imgUrl = (file) =>
    file ? `${process.env.REACT_APP_API}uploads/${file}` : "";

  const getToken = () => localStorage.getItem("ssstoken");

  const showToast = (msg, ms = 3500) => {
    setToast(msg);
    setTimeout(() => setToast(""), ms);
  };

  // page load: heading, paragraphs, banner, pick of the day, steps, approved reviews (10)
  const fetchReviewPage = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}website/reviewus_list?page=1&limit=10`
      );
      if (data?.result === "true") {
        setPageContent(data.page_content || {});
        setPick(data.pick_of_the_day || null);
        setSteps(data.steps || []);
        setReviews(data.reviews?.data || []);
      }
    } catch (err) {
      console.error("ReviewsUs load error:", err);
    }
  };

  useEffect(() => {
    fetchReviewPage();
  }, []);

  // login user ka review approve ho gaya ho to message (sirf ek baar aayega)
  useEffect(() => {
    const token = getToken();
    if (!token) return;

    axios
      .get(`${process.env.REACT_APP_API}website/my_reviewus`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(({ data }) => {
        if (data?.result === "true" && data.show_message) {
          showToast(data.msg, 5000);
        }
      })
      .catch(() => {});
  }, []);

  const closeReviewModal = () => {
    setReviewOpen(false);
    setReviewText("");
    setRating(0);
  };

  const submitReview = async () => {
    if (!reviewText.trim() || rating === 0 || submitting) return;

    const token = getToken();
    if (!token) {
      closeReviewModal();
      showToast("Review dene ke liye pehle login karein");
      return;
    }

    try {
      setSubmitting(true);
      const { data } = await axios.post(
        `${process.env.REACT_APP_API}website/add_reviewus`,
        { comment: reviewText.trim(), rating },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (data?.result === "true") {
        closeReviewModal();
        // pending hai, list me nahi jodte; admin approve karega tab dikhega
        showToast(data.msg, 4500);
      } else {
        showToast(data?.msg || "Kuch galat ho gaya");
      }
    } catch (err) {
      const status = err.response?.status;
      const msg = err.response?.data?.msg;
      if (status === 401 || status === 403) {
        closeReviewModal();
        showToast("Review dene ke liye pehle login karein");
      } else {
        showToast(msg || "Network error, dobara try karein");
      }
    } finally {
      setSubmitting(false);
    }
  };

  // Pick of the Day -> store page
  const goToPickStore = () => {
    if (pick?.store_slug) window.location.href = `/stores/${pick.store_slug}`;
  };

  return (
    <div style={styles.body}>
      <div style={styles.breadcrumb}>
        Home / <b style={{ color: "#111" }}>Review Us</b>
      </div>

      <div style={styles.wrap}>
        {/* Main column */}
        <div style={styles.main}>
          <h1 style={{ fontSize: 26, margin: "0 0 16px" }}>
            {pageContent.title}
          </h1>

          {(pageContent.description || "")
            .split(/\n\s*\n/)
            .filter(Boolean)
            .map((para, i) => (
              <p key={i} style={styles.p}>
                {para}
              </p>
            ))}

          <div style={styles.reviewCta}>
            <span style={{ fontWeight: 700 }}>
              Tell Us About Your Experience!
            </span>
            <button style={styles.btnPrimary} onClick={() => setReviewOpen(true)}>
              Write a Review
            </button>
          </div>

          {/* Admin ki upload ki hui image, na ho to purani static image */}
          <img
            src={
              pageContent.banner_image
                ? imgUrl(pageContent.banner_image)
                : "/assets/images/review.png"
            }
            alt="Testimonial"
            style={styles.testimonialImg}
          />

          <div>
            {reviews.map((r) => (
              <div key={r._id} style={styles.reviewCard}>
                {r.title ? (
                  <h3 style={{ margin: "0 0 6px", fontSize: 16 }}>{r.title}</h3>
                ) : null}
                <p style={{ margin: "0 0 10px", fontSize: 14, color: "#333" }}>
                  {r.comment}
                </p>
                <div style={styles.reviewMeta}>
                  <span style={styles.starRow}>
                    {[1, 2, 3, 4, 5].map((n) =>
                      n <= r.rating ? (
                        <FaStar key={n} size={18} color="#f5c518" />
                      ) : (
                        <FaRegStar key={n} size={18} color="#d8d8d8" />
                      )
                    )}
                  </span>
                  <div style={styles.reviewerBlock}>
                    <FaUserCircle size={22} style={styles.reviewerIcon} />
                    <div style={styles.reviewerText}>
                      <div style={styles.reviewerName}>{r.name}</div>
                      <div style={styles.reviewerDate}>
                        {formatDate(r.createdAt)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Sidebar */}
        <div style={styles.side}>
          {pick && (
            <div
              style={{
                ...styles.pod,
                ...(pick.background_image
                  ? {
                      backgroundImage: `linear-gradient(rgba(58,37,64,.55), rgba(58,37,64,.55)), url(${imgUrl(
                        pick.background_image
                      )})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }
                  : {}),
              }}
              onClick={goToPickStore}
            >
              <div style={styles.podLabel}>Pick of the Day</div>
              <div style={styles.podInner}>
                <div style={styles.brand}>
                  {pick.store_logo ? (
                    <img
                      src={imgUrl(pick.store_logo)}
                      alt={pick.store_name}
                      style={{ maxWidth: 140, maxHeight: 50, objectFit: "contain" }}
                    />
                  ) : (
                    pick.store_name
                  )}
                </div>
                <div style={styles.desc}>{pick.offer_text}</div>
              </div>
            </div>
          )}

          <div style={styles.howBox}>
            <h3 style={{ margin: "0 0 14px", fontSize: 16 }}>
              How CashKaroNa Works?
            </h3>
            {steps.map((step) => (
              <div key={step._id} style={styles.howStep}>
                <img src={imgUrl(step.icon_image)} alt="" style={styles.howIcon} />
                <div>
                  <div style={{ fontWeight: 700, fontSize: 14 }}>{step.title}</div>
                  <div style={{ fontSize: 13, color: "#6b7280" }}>
                    {step.subtitle}
                  </div>
                </div>
              </div>
            ))}
            <a
              href="/get-help"
              style={{ color: "#0b1f6b", fontSize: 13, fontWeight: 700 }}
            >
              Learn More &rarr;
            </a>
          </div>
        </div>
      </div>

      {/* Write a Review modal */}
      {reviewOpen && (
        <div
          style={styles.overlay}
          onClick={(e) => e.target === e.currentTarget && closeReviewModal()}
        >
          <div style={styles.modal}>
            <button style={styles.close} onClick={closeReviewModal}>
              &#10005;
            </button>
            <h2 style={{ margin: "0 0 20px" }}>Write a Review</h2>
            <textarea
              style={styles.textarea}
              placeholder="Tell us about your experience..."
              value={reviewText}
              onChange={(e) => setReviewText(e.target.value)}
            />
            <div style={styles.starPicker}>
              {[1, 2, 3, 4, 5].map((v) => (
                <span
                  key={v}
                  onClick={() => setRating(v)}
                  style={{
                    color: v <= rating ? "#f5c518" : "#d8d8d8",
                    cursor: "pointer",
                  }}
                >
                  ★
                </span>
              ))}
            </div>
            <button
              style={{
                ...styles.btnPrimary,
                width: "100%",
                padding: 14,
                fontSize: 15,
                opacity: reviewText.trim() && rating > 0 && !submitting ? 1 : 0.5,
                cursor:
                  reviewText.trim() && rating > 0 && !submitting
                    ? "pointer"
                    : "not-allowed",
              }}
              disabled={!(reviewText.trim() && rating > 0) || submitting}
              onClick={submitReview}
            >
              {submitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      )}

      {/* Toast */}
      {toast && <div style={styles.toast}>{toast}</div>}
      <Footer />
    </div>
  );
}

const styles = {
  body: { fontFamily: "Arial, Helvetica, sans-serif", color: "#1f2430", background: "#fff" },
  breadcrumb: { padding: "16px 30px 0", fontSize: 14, color: "#e8281a" },
  wrap: { display: "flex", gap: 24, padding: "20px 50px 60px", alignItems: "flex-start" },
  main: { flex: 1, border: "1px solid #e5e7eb", borderRadius: 8, padding: 28 },
  p: { lineHeight: 1.6, color: "#333", fontSize: 15 },
  reviewCta: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderTop: "1px solid #e5e7eb",
    paddingTop: 20,
    marginTop: 10,
  },
  btnPrimary: {
    background: "var(--primary-gradient)",
    color: "#fff",
    border: "none",
    padding: "12px 22px",
    borderRadius: 6,
    fontWeight: 700,
    cursor: "pointer",
    fontSize: 14,
  },
  starRow: { display: "flex", gap: 3, alignItems: "center" },
  testimonialImg: { width: "100%", borderRadius: 8, marginTop: 26, display: "block" },
  reviewCard: { border: "1px solid #e5e7eb", borderRadius: 8, padding: "18px 20px", marginTop: 16 },
  reviewMeta: { display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 13, color: "#6b7280" },
  reviewerBlock: { display: "flex", alignItems: "center", gap: 8 },
  reviewerIcon: { color: "#333", flexShrink: 0 },
  reviewerText: { textAlign: "right" },
  reviewerName: { fontWeight: 600, color: "#1f2430", fontSize: 13 },
  reviewerDate: { fontSize: 12, color: "#6b7280", marginTop: 2 },
  side: { width: 280, display: "flex", flexDirection: "column", gap: 20 },
  pod: {
    background: "linear-gradient(180deg,#7c3f5e,#3a2540)",
    borderRadius: 10,
    color: "#fff",
    overflow: "hidden",
    cursor: "pointer",
  },
  podLabel: { textAlign: "center", fontWeight: 700, padding: "12px 0 6px", fontSize: 15 },
  podInner: { background: "#fff", color: "#222", margin: "0 12px 16px", borderRadius: 8, padding: "20px 16px", textAlign: "center" },
  brand: { fontWeight: 800, fontSize: 20, display: "flex", justifyContent: "center", alignItems: "center", gap: 6 },
  desc: { fontSize: 13, color: "#333", marginTop: 10, lineHeight: 1.5, fontStyle: "italic" },
  howBox: { border: "1px solid #e5e7eb", borderRadius: 8, padding: 18 },
  howStep: { display: "flex", gap: 12, marginBottom: 18 },
  howIcon: { width: 44, height: 44, flexShrink: 0 },
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 50,
  },
  modal: {
    background: "#fff",
    borderRadius: 10,
    padding: "32px 34px",
    width: 420,
    maxWidth: "90vw",
    position: "relative",
    textAlign: "center",
    boxShadow: "0 10px 40px rgba(0,0,0,.2)",
  },
  close: {
    position: "absolute",
    top: 14,
    right: 14,
    width: 32,
    height: 32,
    borderRadius: "50%",
    background: "#f2f2f2",
    border: "none",
    fontSize: 16,
    cursor: "pointer",
  },
  textarea: {
    width: "100%",
    minHeight: 110,
    border: "1px solid #e5e7eb",
    borderRadius: 6,
    padding: 12,
    fontFamily: "inherit",
    fontSize: 14,
    resize: "vertical",
  },
  starPicker: { margin: "20px 0", fontSize: 30, letterSpacing: 8 },
  toast: {
    position: "fixed",
    bottom: 40,
    left: "50%",
    transform: "translateX(-50%)",
    background: "#1f2430",
    color: "#fff",
    padding: "12px 22px",
    borderRadius: 6,
    fontSize: 14,
    zIndex: 60,
  },
};